"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createModuleContainer = exports.AccessibilityLevel = void 0;
const inversify_1 = require("inversify");
/**
 * Set the accessibility level of a dependency in the application.
 */
var AccessibilityLevel;
(function (AccessibilityLevel) {
    /**
     * The dependency is accessible everywhere in the application.
     */
    AccessibilityLevel["Global"] = "global";
    /**
     * The dependency is only accessible in this module.
     */
    AccessibilityLevel["Local"] = "local";
})(AccessibilityLevel = exports.AccessibilityLevel || (exports.AccessibilityLevel = {}));
function createModuleContainer(rootContainer) {
    const localContainer = new inversify_1.Container();
    localContainer.parent = rootContainer;
    const moduleContainer = new Proxy(rootContainer, {
        get(target, p) {
            if (p === "setAccessibility") {
                return (level) => {
                    switch (level) {
                        case AccessibilityLevel.Global:
                            return rootContainer;
                        case AccessibilityLevel.Local:
                            return localContainer;
                        default:
                            throw new Error(`Unknown accessibility level: ${level}`);
                    }
                };
            }
            else
                return target[p];
        },
    });
    return moduleContainer;
}
exports.createModuleContainer = createModuleContainer;
//# sourceMappingURL=container.js.map